import React, { useCallback } from 'react';
import { Switch, Route as ReactRoute, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
  Purchases,
  NewPurchasesProvider,
  FavoritesPage,
  TaxProfiles,
  UpdateContactInfoPage,
  PreferencesPage,
  DetailsPage,
  NinjaDashboardPage,
  AuctionsPage,
  FinCredit,
} from '../pages';

import { UserContextProvider } from '../context/UserProfileContext';
import { userProfileService } from '../services/user-profile';
import NovoPerfil from '../pages/TaxProfiles/newCnpjTax';
import { FavoriteService } from '../services/favorite';
import AppConstants from '../constants/appConstants';
import { UserFavoriteInspectionsContextProvider } from '../context/FavoriteContext';

const favoriteService = new FavoriteService(
  AppConstants.API.userFavorite,
  AppConstants.API.auctions
);

const Route = ({ children, onlyNinja = false, ...props }) => {
  const { user } = useSelector(state => state.authentication);

  const useRender = useCallback(() => {
    if (onlyNinja) {
      return user.isNinja() ? children : <Redirect to="/" />;
    }

    return children;
  }, [user, onlyNinja, children]);

  return <ReactRoute children={useRender} {...props} />;
};

const FavoritesRoute = () => {
  return (
    <UserFavoriteInspectionsContextProvider service={favoriteService} notify={console}>
      <FavoritesPage />
    </UserFavoriteInspectionsContextProvider>
  );
};

export const LoggedRoutes = props => (
  <Switch>
    <Route path="/detalhes/:id">
      <UserContextProvider service={userProfileService} notifier={console}>
        <DetailsPage />
      </UserContextProvider>
    </Route>
    <Route path="/detalhes/">
      <UserContextProvider service={userProfileService} notifier={console}>
        <DetailsPage />
      </UserContextProvider>
    </Route>
    <Route path="/compras">
      <NewPurchasesProvider>
        <Purchases />
      </NewPurchasesProvider>
    </Route>
    <Route path="/favoritos">
      <FavoritesRoute />
    </Route>
    <Route path="/perfis/novo">
      <NovoPerfil />
    </Route>
    <Route path="/perfis">
      <TaxProfiles />
    </Route>
    <Route path="/ferramenta-comercial" onlyNinja>
      <NinjaDashboardPage />
    </Route>
    <Route path="/atualizar-perfil">
      <UpdateContactInfoPage />
    </Route>
    <Route path="/preferencias">
      <PreferencesPage />
    </Route>
    <Route path="/pagamento-facilitado/simule">
      <FinCredit />
    </Route>
    <Route path="/">
      <UserContextProvider service={userProfileService} notifier={console}>
        <AuctionsPage />
      </UserContextProvider>
    </Route>
  </Switch>
);
